export default __webpack_public_path__ + "static/lutein-tired-eyes-da7cf45c8e6092a9c53a419e73a691c6.jpg";